<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	import * as Tooltip from '#lib/components/ui/tooltip/index.js'

	import {
		SIDEBAR_COOKIE_MAX_AGE,
		SIDEBAR_COOKIE_NAME,
		SIDEBAR_WIDTH,
		SIDEBAR_WIDTH_ICON,
	} from './constants'
	import { setSidebar } from './context.svelte'

	let {
		ref = $bindable(null),
		open = $bindable(true),
		onOpenChange = () => {},
		class: className,
		style,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		open?: boolean
		onOpenChange?: (open: boolean) => void
	} = $props()

	const sidebar = setSidebar({
		open: () => open,
		setOpen: (value: boolean) => {
			open = value
			onOpenChange(value)

			// This sets the cookie to keep the sidebar state.
			document.cookie = `${SIDEBAR_COOKIE_NAME}=${open}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`
		},
	})
</script>

<svelte:window onkeydown={sidebar.handleShortcutKeydown} />

<Tooltip.Provider delayDuration={0}>
	<div
		bind:this={ref}
		// eslint-disable-next-line svelte/no-inline-styles
		style:--sidebar-width={SIDEBAR_WIDTH}
		// eslint-disable-next-line svelte/no-inline-styles
		style:--sidebar-width-icon={SIDEBAR_WIDTH_ICON}
		// eslint-disable-next-line svelte/require-optimized-style-attribute
		{style}
		class={cn(
			'group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full',
			className
		)}
		data-slot="sidebar-wrapper"
		{...restProps}
	>
		{@render children?.()}
	</div>
</Tooltip.Provider>
